import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Icon } from 'uikit/icons';
import { Tooltip } from 'uikit/tooltips';
import { Typo } from 'uikit/content';

import { useTruncationCheck } from 'uikit/utils';

import styles from '../styles/uikitManageCustomFilter.module.scss';

const CustomFilter = ({
  filterText = '',
  isFilterSet = false,
  onClearButtonClick = () => {},
  onFilterButtonClick = () => {},
  onFilterTextClick = () => {},
}) => {
  const truncationRef = useRef(null);
  const isTruncated = useTruncationCheck({ ref: truncationRef, deps: [filterText, isFilterSet] });

  const filterTextButton = (
    <button
      aria-label={i18n.t('edit-custom-filter', {
        filterText,
        defaultValue: `Edit custom filter: ${filterText}`,
      })}
      className={styles.filterText}
      onClick={onFilterTextClick}
      ref={truncationRef}
      type="button"
    >
      <Typo element="span" variant="s02">
        {filterText}
      </Typo>
    </button>
  );

  return (
    <div className={styles.element}>
      {isFilterSet ? (
        <span className={styles.filter}>
          <span className={styles.filterIcon}>
            <Icon icon="ai" size={18} />
          </span>
          <Tooltip aria={{ content: null }} content={filterText} disabled={!isTruncated}>
            {filterTextButton}
          </Tooltip>
          <button
            type="button"
            className={styles.clearButton}
            onClick={onClearButtonClick}
            aria-label={i18n.t('clear-filter', 'Clear filter')}
          >
            <Icon icon="close" size={16} />
          </button>
        </span>
      ) : (
        <Button
          isTypeAi
          onClick={onFilterButtonClick}
          size="small"
          text={i18n.t('custom-filter', 'Custom Filter')}
          variant="ghost"
        />
      )}
    </div>
  );
};

CustomFilter.propTypes = {
  filterText: PropTypes.string,
  isFilterSet: PropTypes.bool,
  onClearButtonClick: PropTypes.func,
  onFilterButtonClick: PropTypes.func,
  onFilterTextClick: PropTypes.func,
};

export default CustomFilter;
